import React, { useState, useEffect } from 'react';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { formatDistanceToNow } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

import AsyncSelect from 'react-select/async';

import { toast } from 'react-toastify';

import { IoIosLock, IoMdArrowBack } from 'react-icons/io';

import Swal from 'sweetalert2';

import { Radio, Switch, Col as ColAnt, Row as RowAnt } from 'antd';

import history from '~/services/history';

import { store } from '~/store';

import Breadcumbs from '~/components/Breadcumbs';
import Input from '~/components/Input';
import ModalDesbloqueioUsuario from '~/components/ModalDesbloqueioUsuario';
import ModalInativarUsuario from '~/components/ModalInativarUsuario';

import {
  PageTitle,
  BoxContent,
  Container,
  Content,
  FormContainer,
  BoxForm,
  TitleSection,
  Row,
  Col,
  Label,
  ButtonBox,
  BoxNivelAcesso,
  BoxAsyncSelect,
  SwitchButton,
  BoxBloqueado,
} from './style';

import api from '~/services/api';

import { UserSchema } from '~/utils/schemas/userSchema';
import VALIDATIONS from '~/helpers/validations';
import {
  validateCpf,
  cpfMasked,
  onlyUpperCase,
} from '~/helpers/generalFunctions';
import { phoneMask, cellPhoneMask, cpfMask } from '~/helpers/masks';

const Usuario = props => {
  const [active, setActive] = useState(true);

  const [loading, setLoading] = useState(false);

  const [accessLevel, setAccessLevel] = useState('ROLE_USER');

  const [institution, setInstitution] = useState(null);

  const [institutionId, setInstitutionId] = useState(null);

  const [currentInstitution, setCurrentInstitution] = useState();

  const [dadosUsuario, setDadosUsuario] = useState();

  const { token, roles } = store.getState().auth;

  const [errorinstitution, setErrorinstitution] = useState(false);

  const [acao, setAcao] = useState();

  const [bloqueado, setBloqueado] = useState();

  const [desloquearUsuario, setDesloquearUsuario] = useState(false);

  const [modalInativar, setModalInativar] = useState(false);

  const [cadastroGestor, setCadastroGestor] = useState(null);

  const [retornUserId, setRetornUserId] = useState();

  // adicionar / editar /

  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
  const ROLE_MANAGER = roles.includes('ROLE_MANAGER');
  const ROLE_USER = roles.includes('ROLE_USER');

  if (ROLE_USER) {
    history.push('/');
  }

  const usuarioId = props.match.params.id;

  const onSubmitData = async ({ data }) => {
    const { nome, cargo, cpf, email, telefone } = data;

    if (
      !cadastroGestor &&
      ROLE_ADMIN &&
      !institution &&
      accessLevel !== 'ROLE_ADMIN'
    ) {
      setErrorinstitution(true);
      toast.error('Todos os campos são de preenchimento obrigatório.', {
        autoClose: 6000,
      });
      return;
    }

    const dados = {
      ativo: Boolean(active),
      cargo: cargo?.toUpperCase(),
      cpf: String(cpf)
        .replace(/\./g, '')
        .replace(/\-/g, ''),
      email,
      gestorNome: '',
      idInstituicao: !cadastroGestor
        ? accessLevel === 'ROLE_ADMIN'
          ? 0
          : Number(institutionId) || institution
        : props.location.state.idInstituicao,
      nome: nome?.toUpperCase(),
      permissao: accessLevel,
      telefone,
    };

    if (!data) {
      Swal.fire({
        title: 'Atenção',
        text: 'Verique os dados.',
        icon: 'warning',
        confirmButtonColor: '#74a50a',
      });
      return;
    }

    const escapedData = JSON.stringify(data);
    
    console.log(escapedData);

    let response;
    try {
      setLoading(true);

      if (acao === 'editar') {
        response = await api.put(`/usuarios/${usuarioId}`, dados, {
          headers: {
            Authorization: String(token),
          },
        });
      } else {
        response = await api.post('/usuarios', dados, {
          headers: {
            Authorization: String(token),
          },
        });
      }

      if (String(response?.status).substr(0, 2) === '20' && acao === 'editar') {
        setLoading(false);

        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Alterações salvas
          com sucesso</p>`,
          icon: 'success',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        });
        const { search } = window.location;

        if (search === '?cadastro-gestor=true') {
          setCadastroGestor({ accessLevel: 'USER_MANAGER' });

          setTimeout(() => {
            history.push({
              pathname: `/administrador/selecao-das-linhas-de-cuidado/${cadastroGestor.idInstituicao}`,
              state: {
                id: cadastroGestor.idInstituicao,
                userId: response.data.id,
              },
            });
          }, 800);
        } else {
          setTimeout(() => {
            history.push({
              pathname: '/administrador/usuarios-do-sistema',
            });
          }, 800);
        }
      } else {
        setLoading(false);

        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">Cadastro de novo usuário<br />
           realizado com sucesso!</p>`,
          icon: 'success',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        });

        if (!cadastroGestor) {
          setTimeout(() => {
            history.push({
              pathname: '/administrador/usuarios-do-sistema',
            });
          }, 800);
        } else {
          setTimeout(() => {
            history.push({
              pathname: `/administrador/selecao-das-linhas-de-cuidado/${cadastroGestor.idInstituicao}`,
              state: {
                id: cadastroGestor.idInstituicao,
                userId: response.data.id,
              },
            });
          }, 800);
        }
      }
    } catch (error) {
      Swal.fire({
        title: 'Atenção',
        text: `${
          error?.response?.data?.fields?.length > 0
            ? error?.response?.data?.fields[0]?.exception
            : error?.response?.data?.error
        }`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
      setLoading(false);
    }

    console.log(response);
  };

  const idInst = sessionStorage.getItem('institutionId');
  const getInstituicao = async () => {
    let response;
    try {
      response = await api.get(`/instituicoes/${idInst}/dados-instituicao`, {
        headers: {
          Authorization: String(token),
        },
      });

      const { id, nomeFantasia } = response.data;
      setCurrentInstitution({
        id,
        nomeFantasia,
      });

      setInstitutionId(response.data.id);
    } catch (error) {
      console.log('error', error);
    }
  };

  const getUsuario = async () => {
    const response = await api.get(`usuarios/${usuarioId}`, {
      headers: {
        Authorization: token,
      },
    });

    setDadosUsuario(response.data);
    setInstitution(response.data.idInstituicao);

    setActive(response.data.ativo);
    setAccessLevel(response.data.permissao);
    if (response.data.bloqueado) setBloqueado(true);
  };

  useEffect(() => {
    if (acao === 'editar') {
      getUsuario();
    }
  }, [acao]);

  useEffect(() => {
    const path = window.location.pathname;

    if (path === '/administrador/novo-usuario') {
      setAcao('adicionar');
    } else {
      setAcao('editar');
    }

    if (ROLE_MANAGER) {
      getInstituicao();
    }

    if (props.location.state) {
      setCadastroGestor(props.location.state);
      setAccessLevel('ROLE_MANAGER');
    }

    const { search } = window.location;

    if (search === '?cadastro-gestor=true') {
      setRetornUserId(true);
    }
  }, []);

  useEffect(() => {
    if (errorinstitution) {
      setTimeout(() => {
        setErrorinstitution(false);
      }, 6000);
    }
  }, [errorinstitution]);

  useEffect(() => {
    console.log('institution', institution);
  }, [institution]);

  const filterInstitution = async (inputValue, callback) => {
    const response = await api.get(
      `instituicoes?limit=10&filter=${inputValue}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    const data = response.data.map(hosp => ({
      value: hosp.id,
      label: hosp.nomeFantasia,
    }));

    callback(data);
  };

  const resquestDesbloquearUsuario = async () => {
    setDesloquearUsuario(false);
    try {
      const response = await api.put(
        `usuarios/${usuarioId}/desbloqueio-usuario`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (String(response?.status).substr(0, 2) === '20') {
        Swal.fire({
          html: `<p style="font-size:24px; color:#282828">
      ${response.data.menssagem}
      </p>`,
          icon: 'success',
          confirmButtonColor: '#74a50a',
          confirmButtonText: 'Ok! Obrigado!',
        });
        setBloqueado(false);
      }
    } catch (error) {
      Swal.fire({
        title: '',
        text: `${error.response.data.error}: Não foi possível desbloquear o usuário.`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });
    }
  };

  const confirmaDesbloquearUsuario = () => {
    setDesloquearUsuario(true);
  };

  const cancelarDesloquearUsuario = () => {
    setDesloquearUsuario(false);
  };

  const inativarUsuario = status => {
    if (status === true) {
      setModalInativar(false);
      setActive(false);
    } else {
      setModalInativar(false);
    }
  };

  // useEffect(() => {
  //   if (dadosUsuario && dadosUsuario.telefone)
  //     setPhoneNumber(
  //       Number(String(dadosUsuario.telefone).replace(/([^0-9])+/g, ''))
  //     );
  // }, [dadosUsuario]);

  const theme = theme => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: '#f3f3f3',
    },
  });

  const [changeMark, setChangeMark] = useState(false);

  useEffect(() => {
    if (dadosUsuario) {
      setChangeMark(dadosUsuario?.telefone?.length >= 16 ? true : false);
    }
  }, [dadosUsuario]);

  const formik = useFormik({
    initialValues: {
      ativo: dadosUsuario?.ativo || '',
      cargo: dadosUsuario?.cargo || '',
      cpf: dadosUsuario?.cpf ? cpfMasked(dadosUsuario?.cpf) : '',
      email: dadosUsuario?.email || '',

      idInstituicao: dadosUsuario?.idInstituicao || '',
      nome: dadosUsuario?.nome || '',
      permissao: dadosUsuario?.permissao || '',
      telefone: dadosUsuario?.telefone || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      cargo: VALIDATIONS.requiredString,
      cpf: Yup.string().required('O CPF é obrigatório.'),
      email: VALIDATIONS.requiredString,
      nome: VALIDATIONS.requiredString,
      telefone: VALIDATIONS.requiredString,
    }),
    onSubmit: async (values, { setErrors }) => {
      if (!validateCpf(values.cpf.replace(/\D/g, ''))) {
        setErrors({ cpf: 'Digite um CPF válido.' });
        return;
      }

      onSubmitData({ data: values });
    },
  });

  useEffect(() => {
    const countErrors = Object.keys(formik.errors).length;
    if (formik.isSubmitting && countErrors >= 1) {
      toast.error('Preencha todos os campos obrigatórios.', {
        autoClose: 6000,
      });
    }
  }, [formik.errors]);

  return (
    <>
      <ModalDesbloqueioUsuario
        desloquearUsuario={desloquearUsuario}
        cancelarDesloquearUsuario={cancelarDesloquearUsuario}
        resquestDesbloquearUsuario={resquestDesbloquearUsuario}
      />

      <ModalInativarUsuario
        modalInativar={modalInativar}
        inativarUsuario={inativarUsuario}
      />

      {acao === 'adicionar' ? (
        <Breadcumbs path="novo-usuario" pathTitle="Adicionar novo usuário" />
      ) : (
        <Breadcumbs path={`${usuarioId}`} pathTitle="Editar usuário" />
      )}

      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div>
          {acao === 'adicionar' ? (
            <span>Adicionar novo usuário </span>
          ) : (
            <span>Editar usuário</span>
          )}
        </div>
      </PageTitle>
      <BoxContent>
        <Container>
          <Content>
            {acao === 'adicionar' ? (
              <h3>
                Informe abaixo as <span>informações cadastrais</span> <br />
                do novo usuário:
              </h3>
            ) : (
              <h3>Informações do usuário</h3>
            )}

            {acao === 'editar' && bloqueado && (
              <BoxBloqueado>
                <div className="causaBloqueio">
                  <IoIosLock size={50} />

                  <div>
                    <span>Usuário bloqueado</span>
                    <p>
                      Usuário bloqueado devido 05 falhas sucessivas de login.
                    </p>
                  </div>
                </div>

                <div className="tempoBloqueio">
                  <span>Tempo de bloqueio</span>
                  {/* <p>Usuário bloqueado há 23 minutos e 12 segundos.</p> */}
                  <p>
                    Usuário bloqueado <br /> há{' '}
                    {dadosUsuario.dataUltimoBloqueio &&
                      formatDistanceToNow(
                        new Date(dadosUsuario.dataUltimoBloqueio),
                        { locale: ptBR }
                      )}
                  </p>
                </div>

                <div className="acaoBloqueio">
                  <span>Desbloquear</span>

                  <Switch
                    checked={bloqueado}
                    onClick={() => confirmaDesbloquearUsuario()}
                  />
                </div>
              </BoxBloqueado>
            )}

            <FormContainer>
              <form onSubmit={formik.handleSubmit} method="post">
                <BoxForm>
                  <div className="left">
                    <TitleSection> > Informações de cadastro</TitleSection>

                    <Row>
                      <Col>
                        <Input
                          label="Nome completo: *"
                          name="nome"
                          id="nome"
                          value={formik.values.nome}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'nome',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.nome && formik.touched.nome
                              ? formik.errors.nome
                              : ''
                          }
                        />
                        <p> &nbsp;</p>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Label>Instituição a que pertence: *</Label>

                        {ROLE_ADMIN &&
                          !cadastroGestor &&
                          accessLevel !== 'ROLE_ADMIN' && (
                            <BoxAsyncSelect>
                              <AsyncSelect
                                cacheOptions
                                onChange={item => setInstitution(item.value)}
                                loadOptions={filterInstitution}
                                placeholder={
                                  dadosUsuario
                                    ? dadosUsuario.nomeInstituicao
                                    : 'Selecione a instituição'
                                }
                                noOptionsMessage={() => 'Pesquise pelo nome'}
                                loadingMessage={() => 'Carregando...'}
                                theme={theme}
                              />
                            </BoxAsyncSelect>
                          )}

                        {accessLevel === 'ROLE_ADMIN' && (
                          <input
                            value="ANS"
                            name="instituicao"
                            type="text"
                            disabled
                          />
                        )}

                        {ROLE_MANAGER && (
                          <input
                            defaultValue={
                              currentInstitution
                                ? currentInstitution.nomeFantasia
                                : ''
                            }
                            name="instituicao"
                            onChange={formik.handleChange}
                            type="text"
                            disabled
                          />
                        )}
                        {cadastroGestor && props.location && (
                          <input
                            defaultValue={props.location.state.nomeFantasia}
                            name="instituicaoGestor"
                            type="text"
                            disabled
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="right">
                    <TitleSection> </TitleSection>
                    <br />

                    <Row>
                      <Col>
                        <Input
                          label="CPF: *"
                          name="cpf"
                          id="cpf"
                          defaultValue={formik.values.cpf}
                          maskRegex={cpfMask}
                          onChange={({ target }) => {
                            formik.setFieldValue('cpf', target.value);
                          }}
                          hasError={
                            formik.errors.cpf && formik.touched.cpf
                              ? formik.errors.cpf
                              : ''
                          }
                        />
                        <p>Somente números</p>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Input
                          label="Cargo na Instituição: *"
                          name="cargo"
                          id="cargo"
                          value={formik.values.cargo}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'cargo',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.cargo && formik.touched.cargo
                              ? formik.errors.cargo
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </BoxForm>

                <hr />

                <TitleSection> > Nível de acesso </TitleSection>

                <BoxForm>
                  <RowAnt>
                    {!cadastroGestor && (
                      <ColAnt span={8}>
                        <BoxNivelAcesso
                          accessLevelActive={accessLevel === 'ROLE_USER'}
                        >
                          <Radio
                            checked={accessLevel === 'ROLE_USER'}
                            onClick={() => setAccessLevel('ROLE_USER')}
                          >
                            <span>Operador</span>
                          </Radio>
                          {ROLE_ADMIN ? (
                            <p>
                              Usuário advindo dos hospitais participantes, com
                              autorização para inserir dados para cálculo de
                              indicadores (seja por arquivo ou formulário) e
                              visualizar dados de sua instituição via dashboard.
                            </p>
                          ) : (
                            <p>
                              Usuário com autorização para inserir dados para
                              cálculo de indicadores (seja por arquivo ou
                              formulário) e visualizar dados da sua instituição
                              via dashboard.
                            </p>
                          )}
                        </BoxNivelAcesso>
                      </ColAnt>
                    )}

                    <ColAnt span={8}>
                      <BoxNivelAcesso
                        accessLevelActive={accessLevel === 'ROLE_MANAGER'}
                      >
                        <Radio
                          checked={accessLevel === 'ROLE_MANAGER'}
                          onClick={() => setAccessLevel('ROLE_MANAGER')}
                        >
                          Gestor do Hospital
                        </Radio>
                        {/* {ROLE_ADMIN ? (
                          <p>
                            Usuário advindo dos hospitais participantes, com
                            autorização para inserir dados para cálculo de
                            indicadores (seja por arquivo ou formulário) e
                            visualizar dados de sua instituição via dashboard.
                          </p>
                        ) : ( */}
                        <p>
                          Usuário advindo dos hospitais participantes, com
                          autorização para inserir dados para cálculo de
                          indicadores (seja por arquivo ou formulário) e
                          visualizar dados da sua instituição via dashboard.
                          Também possui permissão para cadastrar usuários,
                          solicitar reabertura de competência e verificar
                          relatórios de operação. É o responsável por enviar,
                          uma vez ao ano, os dados de perfil hospitalar da sua
                          instituição de origem.
                        </p>
                        {/* )} */}
                      </BoxNivelAcesso>
                    </ColAnt>

                    {ROLE_ADMIN && !cadastroGestor && (
                      <ColAnt span={8}>
                        <BoxNivelAcesso
                          accessLevelActive={accessLevel === 'ROLE_ADMIN'}
                        >
                          <Radio
                            checked={accessLevel === 'ROLE_ADMIN'}
                            onClick={() => setAccessLevel('ROLE_ADMIN')}
                          >
                            Administrador
                          </Radio>
                          <p>
                            Funções de usuário administrador para gerenciar
                            cadastros de hospitais/usuários e permitir a
                            reabertura de competências. É o responsável por
                            disponibilizar documentos relevantes na área de
                            suporte. Esse ator pode acessar todos os dados dos
                            hospitais e usuários cadastrados, bem como
                            visualizar dashboards e registros gerais de
                            operações. Também possui permissão para cadastrar
                            usuários de sua instituição, solicitar reabertura de
                            competência e verificar relatórios de operação. É o
                            responsável por enviar, uma vez ao ano, os dados de
                            perfil hospitalar de sua instituição de origem.
                          </p>
                        </BoxNivelAcesso>
                      </ColAnt>
                    )}
                  </RowAnt>
                </BoxForm>

                <hr />

                <BoxForm>
                  <div className="left">
                    <TitleSection> > Informações de contato</TitleSection>

                    <Row>
                      <Col>
                        <Input
                          label="DDD + Telefone: *"
                          name="telefone"
                          id="telefone"
                          placeholder="(00) 0000-0000"
                          value={formik.values.telefone}
                          maskRegex={changeMark ? cellPhoneMask : phoneMask}
                          onChange={({ target }) => {
                            const splitValue = target?.value?.split('');
                            if (splitValue?.[5] === '9') {
                              setChangeMark(true);
                            } else {
                              setChangeMark(false);
                            }
                            formik.setFieldValue('telefone', target?.value);
                          }}
                          hasError={
                            formik.errors.telefone && formik.touched.telefone
                              ? formik.errors.telefone
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="right">
                    <TitleSection> </TitleSection>
                    <br />
                    <Row>
                      <Col>
                        <Input
                          label="Email: *"
                          name="email"
                          id="email"
                          value={formik.values.email}
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'email',
                              onlyUpperCase(target.value)
                            );
                          }}
                          hasError={
                            formik.errors.email && formik.touched.email
                              ? formik.errors.email
                              : ''
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </BoxForm>

                {acao === 'editar' && (
                  <>
                    <hr />

                    <BoxForm>
                      <div className="left">
                        <TitleSection> > Status de atividade</TitleSection>

                        <Row>
                          <Col>
                            <SwitchButton>
                              <Switch
                                checked={active}
                                onClick={() =>
                                  active
                                    ? setModalInativar(true)
                                    : setActive(true)
                                }
                              />
                              {active ? (
                                <span
                                  style={{ marginLeft: 10, color: '#74a50a' }}
                                >
                                  Usuário ativo
                                </span>
                              ) : (
                                <span
                                  style={{ marginLeft: 10, color: '#6c6c6c' }}
                                >
                                  Usuário inativo
                                </span>
                              )}
                            </SwitchButton>
                          </Col>
                        </Row>
                      </div>
                    </BoxForm>
                  </>
                )}

                <ButtonBox>
                  <button type="submit">
                    {loading ? 'Enviando dados...' : 'Salvar'}
                  </button>
                </ButtonBox>
                <span className="alertGreen">*Preenchimento obrigatório</span>
              </form>
            </FormContainer>
          </Content>
        </Container>
      </BoxContent>
    </>
  );
};

export default Usuario;
